module.exports = __webpack_public_path__ + "static/media/cloud-download.fa22af36.svg";